import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';
import type { ReactNode } from 'react';

import parse, { attributesToProps, domToReact, Element as DomElement } from 'html-react-parser';

import { FesLink } from '~/components/shared/core/link/FesLink';

export const parseHtmlWithFesLinks = (html?: string): ReactNode => {
  if (!html) {
    return undefined;
  }

  const options: HTMLReactParserOptions = {
    replace: node => {
      if (!(node instanceof DomElement) || node.name !== 'a') {
        return undefined;
      }

      const { href, target, className, ...rest } = attributesToProps(node.attribs ?? {}) as {
        href?: string;
        target?: string;
        className?: string;
        [key: string]: unknown;
      };

      if (!href) {
        return undefined;
      }

      return (
        <FesLink {...rest} href={href} target={target} className={className}>
          {domToReact(node.children as DOMNode[], options)}
        </FesLink>
      );
    },
  };

  return parse(html, options);
};
